import styled from 'styled-components';

import {Switch} from "@chakra-ui/react";
import {useStoreProfile} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {themecolors} from "../../../utils/themecolors";
import {useActions} from "../../../app_context";
import {useSaveSettings} from "../../../api/user";
import useFeedback from "../../../utils/use_feedback";

const SwitchHeading = styled.div``;
const SwitchDescription = styled.div``;
const SwitchContainer = styled.div``
const SwitchText = styled.div``;
const SwitchItem = styled.div``;

const PrivacySettings = styled(({className}) => {

    const actions = useActions();
    const settings = useStoreProfile();
    const {error, feedbackCh} = useFeedback();
    const saveSettings = useSaveSettings(feedbackCh);
    const apply = async (changes) => {
        actions.settingsChanged(changes);
        await saveSettings(settings);
    };

    return (
        <>
            <FixedTopBar back title="Privacy" border={false}/>
            <WhiteMain className={className}>
                <FormContainer>

                    <SwitchContainer>
                        <SwitchText>
                            <SwitchHeading>Index on Search Engines</SwitchHeading>
                            <SwitchDescription>
                                Your profile will be indexed by search engines.
                            </SwitchDescription>
                        </SwitchText>
                        <SwitchItem>
                            <Switch isChecked={settings.index_profile}
                                    onChange={(value) => apply({index_profile: !settings.index_profile})} />
                        </SwitchItem>
                    </SwitchContainer>

                    <SwitchContainer>
                        <SwitchText>
                            <SwitchHeading>Accept Private Messages</SwitchHeading>
                            <SwitchDescription>
                                Users will be able to send you private messages.
                            </SwitchDescription>
                        </SwitchText>
                        <SwitchItem>
                            <Switch isChecked={settings.accept_private_messages}
                                    onChange={(value) => apply({accept_private_messages: !settings.accept_private_messages})} />
                        </SwitchItem>
                    </SwitchContainer>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }

  ${SwitchDescription} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : 'rgb(89, 96, 104)'};
    font-size: 13px;
  }

  ${SwitchContainer} {
    width: 450px;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
  }

  ${SwitchHeading} {
    font-weight: 600;
    font-size: 14px;
  }

  ${SwitchItem} {
    margin-left: auto;
  }
`;

export default PrivacySettings;
